import { Button } from '@mantine/core';
import { IconDownload } from '@tabler/icons-react';

type ExportPendingTicketButtonProps = {
  loading: boolean;
  onExport: () => void;
};

export function ExportPendingTicketButton({
  loading,
  onExport,
}: ExportPendingTicketButtonProps) {
  return (
    <Button
      display="flex"
      justify="flex-end"
      mx="auto 0"
      leftSection={<IconDownload size={16} />}
      variant="outline"
      size="sm"
      loading={loading}
      onClick={onExport}
    >
      匯出待查繳清單
    </Button>
  );
}
